import { retrieve } from "framework/http/endpoint";
import { createCollectionResponseFactory, createEntityResponseFactory } from "framework/http/rest/jsonResponse";
import { UrlPathOfApiLocation } from "common/paths";
var ClubsApiUri = "".concat(UrlPathOfApiLocation, "/api/1/clubs");
function fromTransportClub(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    return result;
}
function apiGetClubs() {
    return retrieve(ClubsApiUri, null, createCollectionResponseFactory(fromTransportClub));
}
function apiGetClub(id) {
    var uri = "".concat(ClubsApiUri, "/").concat(id);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportClub));
}
export { apiGetClubs, apiGetClub, };
